import React, { useState } from 'react';
import colors from 'src/style/colors';
import { mediaQueries } from 'src/style/breakpoints';

export const faqData = [
  {
    question: "Qu'est-ce que Le Reacteur ?",
    answer:
      "Le Reacteur est une école de code fondée en 2016 par des développeurs expérimentés. Nous formons aux métiers du développement Web et Mobile avec une pédagogie axée sur la pratique, les projets concrets et l'intégration des outils d'IA. Plus de 3000 élèves formés et un taux de satisfaction de 4,9/5.",
  },
  {
    question: 'Dois-je avoir des connaissances en tech ou en IA ?',
    answer:
      "Non, absolument pas ! Nos formations sont conçues pour partir de zéro. Nous vous enseignons d'abord les bases solides du code (HTML, CSS, JavaScript, React, Node.js) avant d'intégrer progressivement l'IA comme accélérateur. Aucun prérequis technique n'est nécessaire.",
  },
  {
    question: 'Comment choisir la bonne formation ?',
    answer:
      "C'est justement pour ça que nous vous proposons de télécharger toutes nos brochures ! Vous pourrez comparer les formats (Bootcamp, E-learning, Alternance) et choisir celui qui correspond le mieux à vos contraintes de temps, votre situation professionnelle et vos objectifs.",
  },
  {
    question: 'Puis-je suivre la formation en travaillant ?',
    answer:
      "Oui ! L'e-learning vous permet d'avancer à votre rythme avec un accompagnement hebdomadaire.",
  },
  {
    question: 'Les formations sont-elles finançables ?',
    answer:
      "Oui ! Nos formations certifiantes sont éligibles au CPF, à France Travail, aux dispositifs Région, Transitions Pro, et bien d'autres. Nous vous accompagnons dans la construction de votre dossier pour trouver la meilleure option de financement selon votre profil.",
  },
  {
    question: 'Vais-je être accompagné·e pendant la formation ?',
    answer:
      "Absolument ! Tous nos formats incluent un accompagnement rapproché : formateurs disponibles, cours de soutien, plateforme e-learning, quiz, challenges, et communauté d'entraide entre élèves. Notre taux de réussite et notre note de 4,9/5 parlent d'eux-mêmes.",
  },
  {
    question:
      "Quelle est la différence entre vos formations et celles qui utilisent seulement l'IA ?",
    answer:
      "Nous ne formons pas à utiliser l'IA à la place du code, mais à utiliser l'IA pour coder mieux et plus vite. Vous apprendrez d'abord les fondamentaux solides (JavaScript, React, Node.js) qui vous permettront de comprendre, corriger et optimiser ce que l'IA génère. Les entreprises recherchent des développeurs qui maîtrisent le code ET l'IA, pas l'un ou l'autre.",
  },
];

const FaqItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      css={{
        backgroundColor: colors.white,
        borderRadius: 12,
        marginBottom: '1rem',
        overflow: 'hidden',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
      }}
    >
      <button
        onClick={() => setIsOpen(!isOpen)}
        css={{
          width: '100%',
          padding: '1.5rem',
          fontWeight: 600,
          fontSize: '1.1rem',
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: 'transparent',
          border: 'none',
          textAlign: 'left',
          color: colors.purpleDark,
          transition: 'background 0.3s ease',
          '&:hover': {
            backgroundColor: colors.lightGrey,
          },
          [mediaQueries.phoneOnly]: {
            fontSize: '1rem',
            padding: '1.25rem',
          },
        }}
      >
        <span css={{ paddingRight: '1rem' }}>{question}</span>
        <span
          css={{
            fontSize: '1.5rem',
            color: colors.purple,
            transition: 'transform 0.3s ease',
            transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)',
            flexShrink: 0,
          }}
        >
          +
        </span>
      </button>
      {isOpen && (
        <div
          css={{
            padding: '0 1.5rem 1.5rem',
            color: colors.darkGrey,
            lineHeight: 1.7,
            [mediaQueries.phoneOnly]: {
              padding: '0 1.25rem 1.25rem',
            },
          }}
        >
          {typeof answer === 'string' && answer.includes('<') ? (
            <div dangerouslySetInnerHTML={{ __html: answer }} />
          ) : (
            answer
          )}
        </div>
      )}
    </div>
  );
};

const FaqSection = ({ items, title }) => {
  const data = items || faqData;

  return (
    <section
      css={{
        padding: '5rem 2rem',
        backgroundColor: colors.white,
        [mediaQueries.phoneOnly]: {
          padding: '3rem 1rem',
        },
      }}
    >
      <div
        css={{
          maxWidth: 800,
          margin: '0 auto',
        }}
      >
        {/* Section Title */}
        <h2
          css={{
            textAlign: 'center',
            fontSize: '2.5rem',
            marginBottom: '3rem',
            color: colors.purpleDark,
            fontWeight: 700,
            [mediaQueries.phoneOnly]: {
              fontSize: '1.75rem',
              marginBottom: '2rem',
            },
          }}
        >
          {title}
        </h2>

        {/* FAQ Items */}
        {data.map((item, index) => (
          <FaqItem key={index} question={item.question} answer={item.answer} />
        ))}
      </div>
    </section>
  );
};

export default FaqSection;
